import { Fragment } from "react";
import { Flex } from "@chakra-ui/react";
import { IconTranslator } from "components/icons/Icons";
import { fetchLanguagesExcerpt } from "network/helper";
import { LanguagesExcerptWithToggle } from "./LanguagesExcerptWithToggle";
import { LanguagesCellProps } from "../types";

export function LanguagesCell({ translatedFrom, translatedTo, textColor }: LanguagesCellProps) {
  return (
    <Flex align="center">
      <Flex
        color={textColor}
        fontSize="14px"
        lineHeight="24px"
        fontWeight="400"
        alignItems={"center"}
      >
        {translatedFrom && translatedTo && (
          <Fragment>
            {fetchLanguagesExcerpt(translatedFrom)}
            <IconTranslator width="15px" height="16px" mx="4px" />
            <LanguagesExcerptWithToggle value={translatedTo} />
          </Fragment>
        )}
      </Flex>
    </Flex>
  );
}
